import React, { useState, useEffect, useContext, useCallback } from "react";
import { ControlContext } from "./ControlContext";
import PremierSportsGraphics from "../Graphics/PremierSports/Graphics.js";
import BasicPack from "../Graphics/BasicPack/Graphics.js";
import SkyPack from "../Graphics/Sky Lima4/Graphics.js";
import { VizContext } from "./VizContext.js";

// const viz = new Viz("FOOTBALL_2020");
const viz = {};
const GraphicsContext = React.createContext([{}, () => {}]);

const GraphicsProvider = (props) => {
  const {
    animate,
    preview,
    update,
    animateOff,
    clearPreview,
    triggerAnimation,
  } = useContext(ControlContext);

  const {
    previewTrio,
    getVizPage,
    updateVizPage,
    takeVizPage,
    takeOutVizPage,
    vizSharedMemory,
    vizClearPreview,
    vizCommand,
    createPage,
    setPageSummary,
    continueVizPage,
  } = useContext(VizContext);

  const [graphics, setGraphics] = useState();

  const [graphicInPreview, setGraphicInPreview] = useState();
  const [style, setStyle] = useState(
    window?.ENV?.REACT_APP_SKY === "true" ||
      process.env.REACT_APP_SKY === "true"
      ? "SKY"
      : "BASIC"
  );
  useEffect(() => {
    switch (style) {
      case "PREMIERSPORTS":
        setGraphics(
          PremierSportsGraphics({
            preview,
            animate,
            update,
            animateOff,
            triggerAnimation,
            clearPreview,
          })
        );
        break;
      case "BASIC":
        setGraphics(
          BasicPack({
            preview,
            animate,
            update,
            animateOff,
            triggerAnimation,
            clearPreview,
          })
        );
        break;
      case "SKY":
        setGraphics(
          SkyPack({
            previewTrio,
            getVizPage,
            updateVizPage,
            takeVizPage,
            takeOutVizPage,
            vizSharedMemory,
            update,
            vizCommand,
            createPage,
            setPageSummary,
            continueVizPage,
          })
        );
        break;
      default:
    }
  }, [style]);

  const previewGraphic = useCallback(
    (name, options) => {
      if (graphics) {
        let graphic = graphics.find((graphic) => graphic.name === name);
        if (graphic) {
          if (graphic && graphic.name !== "CLOCK") {
            setGraphicInPreview(graphic);
          }
          return graphic.preview({ options });
        }
      }
    },
    [preview, graphics]
  );

  const animateGraphic = useCallback(
    (name, options) => {
      let graphic = graphics.find((graphic) => graphic.name === name);
      if (graphic) {
        graphic.animate({ options });
      }
      // if (
      //   style === "SKY" &&
      //   graphic.name === "HeroFormation" &&
      //   graphic.stage === 14
      // ) {
      //   setGraphicInPreview();
      // }
    },
    [animate, graphics]
  );

  const animateOffGraphic = useCallback(
    (name, options) => {
      let graphic = graphics.find((graphic) => graphic.name === name);
      if (graphic) {
        graphic.animateOff({ options });
        setGraphicInPreview();
      }
    },
    [animate, graphics]
  );

  const updateGraphic = useCallback(
    (name, options) => {
      if (graphics) {
        let graphic = graphics.find((graphic) => graphic.name === name);
        if (graphic) {
          graphic.update({ options });
        }
      }
    },
    [animate, graphics]
  );

  const clearPVW = useCallback(
    (name) => {
      clearPreview(name);
      vizClearPreview();
      setGraphicInPreview();
    },
    [graphicInPreview, clearPreview]
  );

  return (
    <GraphicsContext.Provider
      value={{
        previewGraphic,
        animateGraphic,
        graphicInPreview,
        animateOffGraphic,
        updateGraphic,
        clearPVW,
        graphics,
      }}
    >
      {props.children}
    </GraphicsContext.Provider>
  );
};

export { GraphicsContext, GraphicsProvider };
